"use client";

export default function ConnectForm() {
    return (
        <form 
            className="flex flex-col gap-6" 
            onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.currentTarget);
                const name = formData.get('name') as string;
                const email = formData.get('email') as string;
                const phone = formData.get('phone') as string;
                const message = formData.get('message') as string;
                
                // Construct WhatsApp Message
                const waMessage = `*New Transmission*\n\n*Name:* ${name}\n*Email:* ${email}\n*Phone:* ${phone}\n*Message:* ${message}`;
                const encodedMessage = encodeURIComponent(waMessage);
                const waLink = `https://wa.me/917309071010?text=${encodedMessage}`;
                
                // Redirect to WhatsApp
                window.open(waLink, '_blank');
            }}
        >
            <div className="flex flex-col gap-2">
                <label
                    htmlFor="name"
                    className="font-bold uppercase text-[0.9rem]"
                >
                    Name
                </label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    className="p-4 bg-[#e4e2dd] border-[3px] border-[#1a1a1a] font-mono text-[1rem] outline-none transition-all duration-200 focus:bg-white focus:shadow-[2px_2px_0px_#1a1a1a]"
                    placeholder="Your Name"
                    required
                />
            </div>
            <div className="flex flex-col gap-2">
                <label
                    htmlFor="email"
                    className="font-bold uppercase text-[0.9rem]"
                >
                    Email
                </label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    className="p-4 bg-[#e4e2dd] border-[3px] border-[#1a1a1a] font-mono text-[1rem] outline-none transition-all duration-200 focus:bg-white focus:shadow-[2px_2px_0px_#1a1a1a]"
                    placeholder="youremail@example.com"
                    required
                />
            </div>
            <div className="flex flex-col gap-2">
                <label
                    htmlFor="phone"
                    className="font-bold uppercase text-[0.9rem]"
                >
                    Phone
                </label>
                <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="p-4 bg-[#e4e2dd] border-[3px] border-[#1a1a1a] font-mono text-[1rem] outline-none transition-all duration-200 focus:bg-white focus:shadow-[2px_2px_0px_#1a1a1a]"
                    placeholder="+91 XXXXXXXXXX"
                />
            </div>

            <div className="flex flex-col gap-2">
                <label
                    htmlFor="message"
                    className="font-bold uppercase text-[0.9rem]"
                >
                    Message
                </label>
                <textarea
                    id="message"
                    name="message"
                    className="p-4 bg-[#e4e2dd] border-[3px] border-[#1a1a1a] font-mono text-[1rem] outline-none transition-all duration-200 focus:bg-white focus:shadow-[2px_2px_0px_#1a1a1a] min-h-[150px] resize-y"
                    placeholder="Tell us about your exciting project..."
                    required
                ></textarea>
            </div>
            <button type="submit" className="btn w-full">
                Send Transmission (via WhatsApp)
            </button>
        </form>
    );
}
